/**************************************************
 * Nombre:       Tarjeta_Producto_Tiempo_Limitado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import prod from '../../Recursos/Temporales/tmp_prod_tiempo.png'
import {theme} from "../../Tema";
import {useCuentaRegresiva} from "../Secccion/Componentes/Hooks/useCuentaRegresiva";
import dayjs from "dayjs";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Producto_Tiempo_Limitado = () => {
    const {sCell} = useResponsive()
    const {Reloj} = useCuentaRegresiva({fecha: dayjs().add(1, 'hour')})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            direction={'row-reverse'}
            size={{xs: 12, sm: 12, md: 12}}
        sx={{pb: sCell ? 14 : 0}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={prod} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 6}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: -4}}>
                    <Typography
                        sx={{fontSize: 14, fontWeight: 700, lineHeight: 1.2, textAlign: sCell ? 'center' : 'left'}}>
                        EXCLUSIVO PARA ADULTOS
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                    <Typography sx={{
                        fontSize: sCell ? 32 : 40,
                        fontWeight: 800,
                        lineHeight: 1.2,
                        color: '#00000090',
                        textAlign: sCell ? 'center' : 'left',
                        lightingColor: 1.1
                    }}>
                        The Icon: Round Metal
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 0}}>
                    <Typography
                        sx={{fontSize: sCell ? 20 : 24, fontWeight: 300, lineHeight: 1.2, textAlign: sCell ? 'center' : 'left'}}>
                        For Adult, Unisex Style
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2}}>
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            lineHeight: 1.2,
                            color: theme.palette.primary.main,
                            textAlign: sCell ? 'center' : 'left'
                        }}>
                        Find the perfect fit
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 0}}>
                    <Typography
                        sx={{fontSize: 14, fontWeight: 400, lineHeight: 1.2, textAlign: sCell ? 'center' : 'left'}}>
                        For Adult, Unisex Style
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4}}>
                    <Typography
                        sx={{fontSize: 14, fontWeight: 400, lineHeight: 1.2, textAlign: sCell ? 'center' : 'left'}}>
                        Oferta por tiempo limitado
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                    <Reloj/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4}}>
                    <Button sx={{borderRadius: 8, px: 8}}>
                        Comprar
                    </Button>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Producto_Tiempo_Limitado    